/** @jsx jsx */
import React from "react"
import { jsx } from "@emotion/core"
import { colors, TOUCH_TARGET } from "../styles"

export const LogoMarkCircle = ({ color, ...restProps }) => (
  // <div
  //   css={
  //     {
  //       minWidth: "2rem",
  //     }
  //   }

  // >
  <svg
    viewBox="0 0 235 235"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    css={{ minWidth: TOUCH_TARGET, height: "auto" }}
    {...restProps}
  >
    <g id="Logo Circle">
      <path
        /* white lettering */ id="Vector"
        d="M117.14 223.89C176.096 223.89 223.89 176.096 223.89 117.14C223.89 58.1836 176.096 10.39 117.14 10.39C58.1836 10.39 10.39 58.1836 10.39 117.14C10.39 176.096 58.1836 223.89 117.14 223.89Z"
        fill="white"
      />
      <g>
        {" "}
        <path
          id="Vector_2"
          d="M156.91 119.45H176.45C180.495 119.544 184.515 118.802 188.26 117.27C194.91 114.27 198.85 107.64 198.85 98.41C198.85 89.99 195.46 83.61 189.49 80.49C186.547 78.9988 183.299 78.2082 180 78.18C174.3 77.18 155.71 77.37 153 77.37H146.22L148.39 119.45H156.91Z"
          fill={color || colors.BLUE}
        />
        <path
          id="Vector_3"
          d="M31.76 159.62H44.93L51.58 77.37H38.14V65.83H68L95 130C95.9731 132.467 96.7456 135.009 97.31 137.6H97.72C98.3929 135.024 99.2074 132.486 100.16 130L127.31 65.8H178.07C184.221 65.5182 190.365 66.4878 196.13 68.65C207 73.3 214.05 84.56 214.05 98.54C214.05 113.34 206.32 125.28 194.24 129.54C189.108 131.186 183.738 131.966 178.35 131.85H149L150.35 159.85H163.35V171.52H122.84V159.76H135.6L131.93 111.76C131.12 102.39 130.58 95.61 130.17 90.76C129.63 92.66 129.08 94.43 128.4 96.33L104.24 151.71H91.08L66.92 96.1C66.1085 94.0215 65.4403 91.8898 64.92 89.72L64.51 95.15V96.78L62.75 119.31L59.75 159.62H72.48V171.3H31.76V159.62ZM117.14 234.28C140.308 234.28 162.956 227.41 182.219 214.538C201.483 201.667 216.497 183.372 225.363 161.968C234.229 140.563 236.549 117.01 232.029 94.2871C227.509 71.5642 216.353 50.6918 199.97 34.3095C183.588 17.9272 162.716 6.77068 139.993 2.2508C117.27 -2.26907 93.717 0.0506935 72.3125 8.91674C50.9079 17.7828 32.6132 32.7969 19.7416 52.0605C6.87014 71.3241 0 93.9719 0 117.14C0.00795282 148.205 12.352 177.995 34.3183 199.962C56.2846 221.928 86.075 234.272 117.14 234.28Z"
          fill={color || colors.BLUE}
        />
      </g>
    </g>
  </svg>
  // </div>
)

export default LogoMarkCircle
